import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)
// import {api, head} from '../../config.js';
// axios.defaults.baseURL = "http://localhost:7749"
// axios.defaults.baseURL = 'https://cpf-smartfarm.com/production'

const smartfarm_api  = 'https://cpf-smartfarm.com/production'
// const ifarm_api = "https://www.cpfsmartfarmsolution.com"

export default new Vuex.Store({
  state: {
    farm_id: localStorage.getItem('farm_id'),
    user_id: localStorage.getItem('user_id'),
    role: localStorage.getItem('role'),
    token: localStorage.getItem('access-token'),
    verify: localStorage.getItem('verify-token'),
  },
  getters: {
    loggedIn(state) {
      return state.token != null
    },
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token
    },
    destroyToken(state) {
      state.farm_id = null
      state.user_id = null
      state.role = null
      state.token = null
      state.verify = null
    },
  },
  actions: {
    // account
    viewFarmActive(context, data) {
      return new Promise((resolve, reject) => {
        axios.get(smartfarm_api + data.animal + '/api/farm/active',
          {
            headers: {
              'x-access-token': 'BUCVEXFYG2J3K4N6P7Q9SATBVD',
              'X-xss-protection': '1; mode=block',
              'X-frame-options': 'SAMEORIGIN',
              'X-content-type-options': 'nosniff',
              'Cache-Control': 'no-cache, private',
              'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
              'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
            }
          }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    Register(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(smartfarm_api + data.animal + '/api/register', {
          username: data.username,
          password: data.password,
          first_name: data.first_name,
          last_name: data.last_name,
          mobile: data.mobile,
          farm_id: (data.farm_id).toString(),
          role: (data.role).toString()
        },
        {
          headers: {
            'x-access-token': 'BUCVEXFYG2J3K4N6P7Q9SATBVD',
            'X-xss-protection': '1; mode=block',
            'X-frame-options': 'SAMEORIGIN',
            'X-content-type-options': 'nosniff',
            'Cache-Control': 'no-cache, private',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
            'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
          }
        }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    // เพิ่ม Register iFarm
    // iFarmRegister(context, data) {
    //   return new Promise((resolve, reject) => {
    //     axios.post(ifarm_api + '/ifarm/api/account/register/index.php',
    //       data.body,
    //     )
    //     .then(response => {
    //       resolve(response)
    //     })
    //     .catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    Forgot(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(smartfarm_api + data.animal + '/api/forgot_password', {
          username: data.username
        },
        {
          headers: {
            'x-access-token': 'BUCVEXFYG2J3K4N6P7Q9SATBVD',
            'X-xss-protection': '1; mode=block',
            'X-frame-options': 'SAMEORIGIN',
            'X-content-type-options': 'nosniff',
            'Cache-Control': 'no-cache, private',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
            'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
          }
        }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    checkForgot(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(smartfarm_api + data.animal + '/api/check_reset_password', {
          username: data.username,
          token: data.token
        },
        {
          headers: {
            'x-access-token': 'BUCVEXFYG2J3K4N6P7Q9SATBVD',
            'X-xss-protection': '1; mode=block',
            'X-frame-options': 'SAMEORIGIN',
            'X-content-type-options': 'nosniff',
            'Cache-Control': 'no-cache, private',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
            'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
          }
        }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    newPassword(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(smartfarm_api + data.animal + '/api/reset_password', {
          username: data.username,
          token: data.token,
          password: data.password
        },
        {
          headers: {
            'x-access-token': 'BUCVEXFYG2J3K4N6P7Q9SATBVD',
            'X-xss-protection': '1; mode=block',
            'X-frame-options': 'SAMEORIGIN',
            'X-content-type-options': 'nosniff',
            'Cache-Control': 'no-cache, private',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
            'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
          }
        }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },

    // home
    viewFarmAdminAll(context) {
      return new Promise((resolve, reject) => {
        axios.get('/api/farm/admin/all',
          {
            headers: {
              'x-access-token': context.state.token,
              'x-verify-token': context.state.verify,
              'X-xss-protection': '1; mode=block',
              'X-frame-options': 'SAMEORIGIN',
              'X-content-type-options': 'nosniff',
              'Cache-Control': 'no-cache, private',
              'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
              'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
            },
          }
        )
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
      })
    },
    
    destroyToken(context) {
      return new Promise((resolve, reject) => {
        axios.post('/api/logout',
        {},
        {
          headers: {
            'x-access-token': context.state.token,
            'x-verify-token': context.state.verify,
            'X-xss-protection': '1; mode=block',
            'X-frame-options': 'SAMEORIGIN',
            'X-content-type-options': 'nosniff',
            'Cache-Control': 'no-cache, private',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
            'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
          }
        })
        .then(response => {
          localStorage.removeItem('farm_id')
          localStorage.removeItem('user_id')
          localStorage.removeItem('role')
          localStorage.removeItem('access-token')
          localStorage.removeItem('verify-token')
          context.commit('destroyToken')
          resolve(response)
          // console.log(response);
          // context.commit('addTodo', response.data)
        })
        .catch(error => {
          localStorage.removeItem('farm_id')
          localStorage.removeItem('user_id')
          localStorage.removeItem('role')
          localStorage.removeItem('access-token')
          localStorage.removeItem('verify-token')
          context.commit('destroyToken')
          reject(error)
        })
      })   
    },
    retrieveToken(context, data) {
      return new Promise((resolve, reject) => {
        axios.post(smartfarm_api + data.animal + '/api/login', {
          username: data.username,
          password: data.password
        },
        {
          headers: {
            'x-access-token': 'BUCVEXFYG2J3K4N6P7Q9SATBVD',
            'X-xss-protection': '1; mode=block',
            'X-frame-options': 'SAMEORIGIN',
            'X-content-type-options': 'nosniff',
            'Cache-Control': 'no-cache, private',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
            'Content-Security-Policy':  'upgrade-insecure-requests; frame-ancestors self'
          }
        })
        .then(response => {
          if(response.data.token !== undefined){
            const farm_id = response.data.user.farm_id
            const user_id = response.data.user.user_id
            const role = response.data.user.role
            const token = response.data.token
            const verify = response.data.verify
            localStorage.setItem('farm_id', farm_id)
            localStorage.setItem('user_id', user_id)
            localStorage.setItem('role', role)
            localStorage.setItem('access-token', token)
            localStorage.setItem('verify-token', verify)
          }
          resolve(response)
          context.commit('retrieveToken', response.data.token)
          // console.log(response)
        })
        .catch(error => {
          reject(error)
          console.log(error)
        })
      })
    },
  },
  modules: {
  }
})
